import {assetManager} from '@resurs-internal/rb-app-api/features/assets/assetManager';

export const getBrand = (chainId: string | number | undefined) => {
  const asset = assetManager.getAssetById(chainId);
  if (asset) return asset;
  return null;
};
